import { useParams, Link } from "react-router-dom";
import { resolveSlug } from "@/lib/routes";
import ServicoPage from "@/pages/ServicoPage";
import BairroPage from "@/pages/BairroPage";
import ServicoBairroPage from "@/pages/ServicoBairroPage";
import { Seo } from "@/components/Seo";

export const NotFound = () => (
  <main className="max-w-3xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
    <Seo title="Página não encontrada | Desentupidora em Guarulhos" description="A página que você procura não existe. Conheça nossos serviços de desentupimento 24h em Guarulhos." path="/404" />
    <h1 className="font-heading font-black text-5xl text-brand-red">404</h1>
    <p className="text-gray-600 mt-4 mb-8">A página que você procura não foi encontrada.</p>
    <Link to="/" className="inline-flex bg-brand-red hover:bg-brand-redDark text-white font-heading font-bold px-8 py-4 rounded-full transition-colors" data-testid="not-found-home-link">
      Voltar para a página inicial
    </Link>
  </main>
);

export default function SlugResolver() {
  const { slug } = useParams();
  const match = resolveSlug(slug);
  if (!match) return <NotFound />;
  if (match.type === "service") return <ServicoPage service={match.service} />;
  if (match.type === "bairro") return <BairroPage bairro={match.bairro} />;
  return <ServicoBairroPage service={match.service} bairro={match.bairro} />;
}
